import { useEffect, useState } from "react";
import { Loader2, Inbox, BookOpen } from "lucide-react";
import api from "@/lib/api";
import { fmtAmount, fmtDate } from "@/lib/render";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export default function LedgerPage() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/ledger").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <BookOpen className="h-6 w-6 text-indigo-400" /> Double-Entry Ledger
        </h1>
        <p className="text-sm text-muted-foreground mt-1">Immutable audit stream — every financial movement recorded as debit/credit</p>
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="border-border hover:bg-transparent">
                {["Entry", "Account", "Amount", "Ccy", "Balance After", "Txn Ref", "Time"].map((h) => (
                  <TableHead key={h} className="text-muted-foreground text-xs uppercase tracking-wider">{h}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows === null && <TableRow><TableCell colSpan={7} className="text-center py-16"><Loader2 className="h-5 w-5 animate-spin mx-auto text-muted-foreground" /></TableCell></TableRow>}
              {rows?.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-16 text-muted-foreground"><Inbox className="h-8 w-8 mx-auto mb-2 opacity-50" />No ledger entries yet</TableCell></TableRow>}
              {rows?.map((e) => (
                <TableRow key={e.id} data-testid="ledger-table-row" className="border-border hover:bg-accent/60 transition-colors">
                  <TableCell>
                    <Badge className={e.entry_type === "credit"
                      ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30 uppercase"
                      : "bg-red-500/15 text-red-300 border-red-500/30 uppercase"}>{e.entry_type}</Badge>
                  </TableCell>
                  <TableCell className="text-foreground">{e.account_name}</TableCell>
                  <TableCell className="font-mono">{fmtAmount(e.amount)}</TableCell>
                  <TableCell className="font-mono text-xs">{e.currency}</TableCell>
                  <TableCell className="font-mono text-foreground">{fmtAmount(e.balance_after)}</TableCell>
                  <TableCell className="font-mono text-xs text-muted-foreground">{String(e.transaction_id).slice(0, 8)}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{fmtDate(e.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
